/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserSecurityClearanceCreateRequest
 */
export interface UserSecurityClearanceCreateRequest {
    /**
     * 
     * @type {number}
     * @memberof UserSecurityClearanceCreateRequest
     */
    maxSecurityLevel: number;
    /**
     * 
     * @type {Date}
     * @memberof UserSecurityClearanceCreateRequest
     */
    expiresAt?: Date;
}

/**
 * Check if a given object implements the UserSecurityClearanceCreateRequest interface.
 */
export function instanceOfUserSecurityClearanceCreateRequest(value: object): value is UserSecurityClearanceCreateRequest {
    if (!('maxSecurityLevel' in value) || value['maxSecurityLevel'] === undefined) return false;
    return true;
}

export function UserSecurityClearanceCreateRequestFromJSON(json: any): UserSecurityClearanceCreateRequest {
    return UserSecurityClearanceCreateRequestFromJSONTyped(json, false);
}

export function UserSecurityClearanceCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserSecurityClearanceCreateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'maxSecurityLevel': json['maxSecurityLevel'],
        'expiresAt': json['expiresAt'] == null ? undefined : (new Date(json['expiresAt'])),
    };
}

export function UserSecurityClearanceCreateRequestToJSON(json: any): UserSecurityClearanceCreateRequest {
    return UserSecurityClearanceCreateRequestToJSONTyped(json, false);
}

export function UserSecurityClearanceCreateRequestToJSONTyped(value?: UserSecurityClearanceCreateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'maxSecurityLevel': value['maxSecurityLevel'],
        'expiresAt': value['expiresAt'] == null ? undefined : ((value['expiresAt']).toISOString()),
    };
}

